// PrimeBrandMark.jsx — PRIME-BRAND-UX-001 AC-02.
//
// The single, swappable primary PRIME mark. Every surface that renders the
// PRIME identity (today: the shell side rail) uses this component, so the brand
// lives in exactly ONE place.
//
// ── Logo swap (one-line change) ────────────────────────────────────────────
// The approved PRIME logo asset is an EXTERNAL DEPENDENCY that has not landed
// yet. Until it does, this renders a polished typographic PRIME wordmark tuned
// to the shell's navy/brand tokens (crisp at every rail width and on high-DPI
// displays — it is live text / vector, never a raster).
//
// When the coordinator drops the approved file at
//   apps/web/public/brand/prime-logo.svg
// swap the brand by editing exactly ONE line below:
//   const PRIME_LOGO_ASSET = null;   →   const PRIME_LOGO_ASSET = '/brand/prime-logo.svg';
// The component then renders the asset in place of the wordmark, keeps the same
// accessible name, and every consuming surface updates with no further edits.
const PRIME_LOGO_ASSET = null;

// AC-04: the mark's accessible name identifies PRIME accurately and in full.
export const PRIME_MARK_ACCESSIBLE_NAME =
  'PRIME — Program Resource and Intelligence Management Engine';

/**
 * The primary PRIME brand mark.
 *
 * @param {object} props
 * @param {string} [props.variant='rail'] Visual context hook ('rail' today).
 *   Styling is class-driven so the same mark can be re-skinned per surface
 *   without changing its markup or accessible name.
 * @param {string} [props.className] Extra classes for the host element.
 */
export function PrimeBrandMark({ variant = 'rail', className = '' }) {
  const hostClass = ['prime-brand-mark', `prime-brand-mark--${variant}`, className]
    .filter(Boolean)
    .join(' ');

  return (
    // role="img" + aria-label give the mark a single, correct accessible name
    // (naming is permitted on role="img", so this passes the axe
    // aria-prohibited-attr sweep the shell tests enforce). Inner content is
    // aria-hidden so the wordmark letters are not announced separately.
    <span className={hostClass} role="img" aria-label={PRIME_MARK_ACCESSIBLE_NAME}>
      {PRIME_LOGO_ASSET ? (
        <img className="prime-brand-mark-img" src={PRIME_LOGO_ASSET} alt="" aria-hidden="true" />
      ) : (
        <span className="prime-brand-wordmark" aria-hidden="true">
          <span className="prime-brand-wordmark-text">PRIME</span>
        </span>
      )}
    </span>
  );
}

export default PrimeBrandMark;
